import React from 'react';
import styles from "./TitleText.module.css"
const TitleText = ({ title1, title2, position }) => {
    return (
        <div>
            <h2 style={{ textAlign: position }} className={styles.title}><span >{title1}</span> <span className={styles.title2}>{title2}</span></h2>
        </div >
    );
};

export default TitleText;